import React from 'react'
import "./category.css"
import { CategoryType } from '../../layout/Main/Main'

const Category = ({category, index, selectedCategory, onCategoryChange}:{category:string, index:number, selectedCategory:string, onCategoryChange:(category:CategoryType)=>void}) => {

  return (
    <button onClick={() => onCategoryChange(category as CategoryType)} type='button' id='category' className={`${selectedCategory === category && "selected"}`}>
      <span>{index+1}</span>
      <p>{category}</p>
    </button>
  )
}

export default Category
